import classNames from 'classnames'
import { StaticIcon } from 'components/common/StaticIcon'
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useRef, useState } from 'react'
import { ContainerElement } from 'types'
import { isTextClamped } from 'utils/strings'

export function CollapsableTextContent({
  children,
  className,
}: ContainerElement) {
  const { t } = useTranslation()
  const [hasReadMore, setHasReadMore] = useState(false)
  const [readMore, setReadMore] = useState(true)

  const descriptionRef = useRef<HTMLParagraphElement | null>(null)

  useEffect(() => {
    if (
      descriptionRef.current &&
      descriptionRef.current?.scrollHeight &&
      descriptionRef.current?.clientHeight
    ) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      setHasReadMore(prev => prev || isTextClamped(descriptionRef.current!))
    }
  }, [
    descriptionRef.current?.scrollHeight,
    descriptionRef.current?.clientHeight,
  ])

  if (!children) return null

  return (
    <>
      <div
        ref={descriptionRef}
        className={classNames(
          'whitespace-pre-line text-sm font-normal md:text-base',
          readMore && 'line-clamp-5 lg:line-clamp-3',
          className
        )}
      >
        {children}
      </div>

      {hasReadMore && (
        <button
          type='button'
          className='mt-2.5 inline-flex cursor-pointer items-center text-sm font-medium text-secondary-default'
          onClick={() => setReadMore(!readMore)}
        >
          {readMore ? t('common:read_more') : t('common:read_less')}
          <StaticIcon
            name='chevronDown'
            className={classNames('ml-2', {
              'rotate-180': !readMore,
            })}
          />
        </button>
      )}
    </>
  )
}
